<template>
  <div class="authority-manage account-box position-header">
    <navHeader :titleList="['子账号管理']" />
    <div class="rhBrand-content common-padding">
      <el-card class="box-card">
        <el-row class="common-row">
          <el-col :span="5">
            <span class="search-text">登录邮箱：</span>
            <el-input
                class="search-item"
                placeholder="请输入"
                v-model.trim="username"
                clearable
                size="small"
            ></el-input>
          </el-col>
          <el-col :span="5">
            <span class="search-text">手机号码：</span>
            <el-input
                class="search-item"
                placeholder="请输入"
                v-model.trim="phone"
                clearable
                size="small"
            ></el-input>
          </el-col>
          <el-col :span="4">
            <el-button
                class="btn-search"
                size="small"
                round
                icon="el-icon-search"
                @click="getPageList"
            >搜索</el-button
            >
            <el-button
                type="warning"
                size="small"
                round
                icon="el-icon-refresh"
                @click="reset"
            >重置</el-button
            >
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card flex-1 table-card">
        <el-row>
          <el-col :span="12">
            <el-button
                class="btns-add"
                icon="el-icon-plus"
                size="small"
                @click="add"
            >添加</el-button
            >
<!--            <el-button-->
<!--                :disabled="selectData.length === 0"-->
<!--                type="danger"-->
<!--                icon="el-icon-delete"-->
<!--                size="small"-->
<!--                @click="deleteMore"-->
<!--            >批量删除</el-button-->
<!--            >-->
            <!-- <el-button
              :disabled="selectData.length === 0"
              type="warning"
              icon="el-icon-sell"
              size="small"
              @click="exportAll"
              >全部导出</el-button
            > -->
          </el-col>
        </el-row>
        <el-row class="common-margin flex-1 table-main">
          <el-table
              :data="tableData"
              border
              class="flex-1" stripe height="100%"
              style="width: 100%"
              @selection-change="selectRow"
          >
            <el-table-column type="selection" width="60px" align="center"> </el-table-column>
            <el-table-column prop="name" align="center" label="姓名">
            </el-table-column>
            <el-table-column prop="username" align="center" label="登录邮箱">
            </el-table-column>
            <el-table-column prop="mobile" align="center" label="登录手机号">
            </el-table-column>
            <el-table-column prop="position" align="center" label="职位">
            </el-table-column>
            <el-table-column align="center" width="180" label="操作">
              <template slot-scope="scope">
                <div class="btn-box">
                  <el-button
                      icon="el-icon-edit"
                      type="text"
                      @click="edit(scope.row.id)"
                      size="small"
                  >编辑</el-button
                  >
                  <el-button type="text" icon="el-icon-d-caret" size="small" @click="upAndDown(scope.row.id, scope.row.shelfStatus)">
                    {{scope.row.shelfStatus === '1' ? '禁用' : '启用'}}
                  </el-button>
<!--                  <el-button-->
<!--                      icon="el-icon-delete"-->
<!--                      type="text"-->
<!--                      @click="deleteInfo(scope.row.id)"-->
<!--                      size="small"-->
<!--                  >删除</el-button-->
<!--                  >-->
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              :current-page.sync="currentPage"
              @current-change="handleCurrentChange"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="total"
          >
          </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader.vue'
import verifyDialog from '../../components/verifyDialog.vue'

export default {
  data () {
    return {
      username: '',
      phone: '',
      time: [],
      status: '',
      statuses: [
        {
          label: '所有',
          value: '1'
        },
        {
          label: '未审核',
          value: '2'
        },
        {
          label: '审核通过',
          value: '3'
        },
        {
          label: '已驳回',
          value: '4'
        }
      ],
      selectData: [],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  components: {
    navHeader,
    verifyDialog
  },
  created () {
    this.getPageList()
  },
  mounted () {},
  methods: {
    async getPageList () {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        username: this.username,
        mobile: this.phone
      }
      let { data: res } = await this.$http.post('/subAccount/getPageList', params)
      if (res.code === '200') {
        console.log(res)
        this.tableData = res.data.records
        this.total = parseInt(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    reset () {
      this.username = ''
      this.phone = ''
      this.getPageList()
    },
    selectRow (selection) {
      this.selectData = selection
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    add () {
      this.$router.push({
        name: 'Account',
        params: {
          type: 'add'
        }
      })
    },
    edit (id) {
      this.$router.push({
        name: 'Account',
        params: {
          id,
          type: 'edit'
        }
      })
    },
    deleteMore () {
      this.$confirm(`确认删除选中的${this.selectData.length}条数据?`, '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        let ids = this.selectData.map(item => item.id)
        ids = ids.join(',')
        this.$http.post('/subAccount/batchDelete', { ids }).then(res => {
          if (res.data.code === '200') {
            this.$message.success(res.data.msg)
            this.getPageList()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    exportAll () {
      this.$confirm(
        `确认导出选中的${this.selectData.length}条数据?`,
        '导出提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          showClose: false
        }
      )
        .then(() => {
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    deleteInfo (id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      })
        .then(() => {
          this.$http.post('/subAccount/delete', {id}).then(res => {
            console.log(res)
            if (res.data.code === '200') {
              this.$message.success(res.data.msg)
              this.getPageList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    upAndDown (id, shelfStatus) {
      let tip = ''
      let status = ''
      if (!shelfStatus || shelfStatus === '2') {
        tip = '确定启用?'
        status = '1'
      } else {
        tip = '确定禁用?'
        status = '2'
      }
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http
          .post('/subAccount/modifyShelfStatus', { id, shelfStatus: status })
          .then((res) => {
            if (res.data.code === '200') {
              this.$message.success(res.data.msg)
              this.getPageList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(() => {
          })
      })
    }
  }
}
</script>

<style lang="less">
.account-box {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/businessInfo/children-account.vue